<div
	*ngIf="isLoading"
	class="flex flex-col items-center justify-center pt-6 pb-10 xl:pt-16 dark-grey-texts"
>
	<app-page-loader></app-page-loader>
</div>
<div
	*ngIf="!isLoading"
	class="flex flex-col items-center justify-center pt-6 pb-10 xl:pt-16 dark-grey-texts"
>
	<div class="w-[100%] md:w-[80%] xl:w-[60%]">
		<form [formGroup]="this.createFundraiserForm">
			<div *ngIf="step === 3">
				<div
					class="flex justify-between items-center pl-6 pr-6 md:pl-0 md:pr-0"
				>
					<h1 class="reset-spacing" i18n="@@createFundraiser_heading_label">
						Start Fundraiser
					</h1>
					<span
						class="text-[#32bf55] font-400"
						i18n="@@start_fundraiser_third_step_number"
						>Step 3/4</span
					>
				</div>
				<div
					class="flex flex-col justify-start md:rounded-lg p-6 mt-4 border border-solid border-color gap-1"
				>
					<div class="flex flex-col mb-2">
						<span
							class="text-16 font-500"
							i18n="@@createFundraiser_title_and_url"
							>Fundraiser Title & URL</span
						>
						<span i18n="@@createFundraiser_title_and_url_content"
							>Your title becomes your fundraiser's URL, making it easy to find
							and share. Keep it short, heartfelt, and specific — help people
							understand who it's for and why.</span
						>
					</div>
					<!-- TITLE -->
					<div classs="flex flex-col">
						<mat-form-field class="w-full" appearance="outline">
							<mat-label i18n="@@editAbout_fundraiser_title"
								>Fundraiser Title</mat-label
							>
							<input
								required
								class="fundraiserTitle"
								matInput
								formControlName="title"
								(input)="setSlug($event)"
								#title
								placeholder="{{ createFundraiserFundTitle }}"
							/>
							<mat-hint class="w-full text-right"
								>{{ title.value.length }} / 5-75
								<span i18n="@@characters_translation">Characters</span>
							</mat-hint>
							<mat-error
								i18n="@@createFundraiser_error"
								*ngIf="
									createFundraiserForm.controls['title'].errors &&
									createFundraiserForm.controls['title'].errors.pattern
								"
							>
								Wrong title. You can only use letters and numbers.
							</mat-error>
							<mat-error
								i18n="@@createFundraiser_mustBeBetween_error"
								*ngIf="
									createFundraiserForm.controls['title'].errors &&
									(createFundraiserForm.controls['title'].errors.minlength ||
										createFundraiserForm.controls['title'].errors.maxlength)
								"
							>
								Must be between 5 - 75 characters
							</mat-error>
						</mat-form-field>
					</div>
					<div class="flex flex-col">
						<mat-slide-toggle
							color="primary"
							(change)="onCustomUrlToggle($event.checked)"
						>
							<span class="text-16 font-500" i18n="@@custom_fundraiser_url"
								>Custom Fundraiser Url</span
							>
						</mat-slide-toggle>
						<span class="mb-3 mt-1" i18n="@@custom_fundraiser_url_content"
							>Want a different link? Just turn on the Custom URL toggle before
							moving ahead.</span
						>
						<mat-form-field
							class="w-100 dark-grey-texts-bg"
							appearance="outline"
							[ngClass]="{ 'custom-url-disabled': !customUrlEnabled }"
						>
							<mat-label i18n="@@fundraiser_createFundraiser_linkName_label"
								>Link Name</mat-label
							><span class="pl-3 grey-texts" matPrefix>whydonate.com/../</span>
							<input
								required
								class="linkUrl"
								matInput
								placeholder="{{ createFundraiserlinkname }}"
								formControlName="custom_url"
								(input)="setSlug($event)"
								#customUrl
								[readonly]="!customUrlEnabled"
								[ngClass]="{
									'cursor-not-allowed': !customUrlEnabled
								}"
							/><mat-icon matSuffix *ngIf="isSlugChecking" class="m-l-xs">
								<mat-spinner color="accent" diameter="16"></mat-spinner>
							</mat-icon>
							<mat-hint class="w-full text-right"
								>{{ customUrl.value.length }} / 1-75
								<span i18n="@@characters_translation">Characters</span>
							</mat-hint>
							<mat-error
								i18n="@@createFundraiser_error"
								*ngIf="
									createFundraiserForm.controls['custom_url'].errors &&
									createFundraiserForm.controls['custom_url'].errors.pattern
								"
							>
								Wrong url. You can only use letters and numbers.
							</mat-error>
							<mat-error
								i18n="@@createFundraiser_urlAlreadyUsed_error"
								*ngIf="
									createFundraiserForm.controls['custom_url'].errors &&
									createFundraiserForm.controls['custom_url'].errors[
										'slugInUse'
									]
								"
							>
								Url already in use
							</mat-error>
							<!-- <mat-hint
								align="start"
								*ngIf="!createFundraiserForm.controls['custom_url'].errors"
								[ngStyle]="{ color: '#66bb6a' }"
								>Url is good</mat-hint
							> -->
						</mat-form-field>
					</div>
					<div class="flex flex-col mb-2">
						<span class="text-16 font-500" i18n="@@createFundraiser_story"
							>Fundraiser Story</span
						>
					</div>
					<div classs="flex flex-col" *ngIf="descriptionInputVisible">
						<mat-form-field class="w-full" appearance="outline">
							<textarea
								#descriptionTextarea
								matInput
								[formControl]="descriptionControl"
								rows="5"
								autofocus
							></textarea>

							<mat-hint class="w-full text-right">
								{{
									createFundraiserForm.get('description')?.value?.length || 0
								}}
								/ 15-15000
								<span i18n="@@characters_translation">Characters</span>
							</mat-hint>
							<mat-error
								*ngIf="
									createFundraiserForm.get('description')?.hasError('required')
								"
								i18n="@@createFundraiser_description_required"
							>
								Description is required
							</mat-error>
							<mat-error
								*ngIf="
									createFundraiserForm.get('description')?.hasError('minlength')
								"
								i18n="@@createFundraiser_description_minlength"
							>
								Minimum 15 characters required
							</mat-error>
							<mat-error
								*ngIf="
									createFundraiserForm.get('description')?.hasError('maxlength')
								"
								i18n="@@createFundraiser_description_maxlength"
							>
								Maximum 15000 characters allowed
							</mat-error>
						</mat-form-field>
					</div>
					<div
						*ngIf="!descriptionInputVisible"
						(click)="showDescriptionInput()"
					>
						<div
							(mouseenter)="isHovered = true"
							(mouseleave)="isHovered = false"
							class="flex flex-col justify-start rounded-md p-4 border border-solid gap-1"
							[ngStyle]="{
								'border-color': isHovered ? '#5b5757' : '#afaca7'
							}"
						>
							<span
								class="text-16 font-500 flex flex-row grey-texts"
								i18n="@@createFundraiser_description_label"
							>
								Tell your story with heart/ Share Your Story (This is where the
								magic happens!)
							</span>
							<span
								class="text-16 font-400 flex flex-row grey-texts"
								i18n="@@createFundraiser_description_label_content"
							>
								Share what happened, why you need help, and how funds will be
								used. Be honest, personal, and easy to read — and photos can
								make your story even more powerful</span
							><br />
						</div>
						<div class="flex flex-row w-full items-end justify-end">
							<span class="text-12">0 / 15-15000</span>&nbsp;<span
								class="text-12 mr-7"
								i18n="@@characters_translation"
								>Characters</span
							>
						</div>
					</div>
					<div class="flex flex-col mb-2">
						<span
							class="text-16 font-500"
							i18n="@@createFundraiser_step3_media_heading"
							>Cover Page Image/ Video</span
						>
					</div>
					<ng-container *ngIf="imagePath && !videoPath">
						<ng-container [ngTemplateOutlet]="imageContainer"></ng-container>
						<div class="flex flex-col items-center">
							<h2 class="reset-spacing" i18n="@@capital_text_or">OR</h2>
						</div>
						<ng-container [ngTemplateOutlet]="videoContainer"></ng-container>
					</ng-container>
					<ng-container *ngIf="!imagePath || videoPath">
						<ng-container [ngTemplateOutlet]="videoContainer"></ng-container>
						<div class="flex flex-col items-center">
							<h2 class="reset-spacing" i18n="@@capital_text_or">OR</h2>
						</div>
						<ng-container [ngTemplateOutlet]="imageContainer"></ng-container>
					</ng-container>

					<div class="flex flex-col mt-4">
						<!-- <mat-divider></mat-divider> -->
					</div>
					<div
						[class]="
							'flex w-full lg:static fixed left-0 right-0 z-50 bg-white pt-2 border-t border-gray-200 ' +
							bottomOffset
						"
					>
						<div
							class="pr-6 pl-6 pb-3 pt-1 sm:pr-6 sm:pl-[80px] sm:pb-3 sm:pt-1 lg:pb-0 lg:pr-0 lg:pl-0 lg:pt-0 justify-between flex w-full"
						>
							<button
								mat-stroked-button
								(click)="backToLastPage()"
								color="accent"
								class="min-h-[48px] h-auto"
							>
								<span class="text-20 font-500 p-6" i18n="@@backButton"
									>Back</span
								>
							</button>
							<button
								mat-flat-button
								(click)="goToNextStep()"
								color="accent"
								class="min-h-[48px] h-auto"
								[disabled]="
									!createFundraiserForm.valid ||
									createFundraiserForm
										.get('custom_url')
										?.hasError('slugInUse') ||
									(!imagePath && !createFundraiserForm.get('VideoName')?.value)
								"
							>
								<span class="text-20 font-500 p-6" i18n="@@button_next"
									>Next</span
								>
							</button>
						</div>
					</div>
				</div>
			</div>

			<div *ngIf="step === 4">
				<div
					class="flex justify-between items-center pl-6 pr-6 md:pl-0 md:pr-0"
				>
					<h1 class="reset-spacing" i18n="@@createFundraiser_heading_label">
						Start Fundraiser
					</h1>
					<span
						class="text-[#32bf55] font-400"
						i18n="@@start_fundraiser_second_four_number"
						>Step 4/4</span
					>
				</div>
				<div
					class="flex flex-col justify-start md:rounded-lg p-6 mt-4 border border-solid border-color gap-1"
				>
					<div class="flex flex-col mb-2">
						<span
							class="text-16 font-500"
							i18n="@@createFundraiser_step4_currency_label"
							>Set Currency</span
						>
					</div>
					<div class="flex flex-col">
						<mat-form-field appearance="outline" class="w-100 currency">
							<mat-label i18n="@@select_currency">Select Currency</mat-label>
							<input
								matInput
								type="text"
								placeholder="Search Currency"
								[formControl]="currencySearchControl"
								aria-label="Search Currency"
								[matAutocomplete]="currencyAuto"
								#currencyInput
							/><button mat-icon-button matSuffix>
								<mat-icon>arrow_drop_down</mat-icon>
							</button>
							<mat-autocomplete #currencyAuto="matAutocomplete">
								<mat-option
									*ngFor="let currencyData of filteredCurrencies | async"
									[value]="currencyData.currency"
									(onSelectionChange)="onCurrencySelect(currencyData)"
								>
									<span>{{ currencyData.symbol }}</span
									>&nbsp;
									<span>{{ currencyData.currency | uppercase }}</span>
								</mat-option>
							</mat-autocomplete>
						</mat-form-field>
					</div>
					<div class="flex flex-col p-5 gap-1 qrCodeBackground">
						<div class="flex w-full items-center justify-start mb-2">
							<div class="flex items-center gap-3">
								<img
									src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/blueInfo/public"
									alt="Info"
								/>
								<h2
									class="reset-spacing"
									i18n="@@create_fundraiser_important_information_title"
								>
									Important Information
								</h2>
							</div>
						</div>
						<div class="flex">
							&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
								i18n="@@create_fundraiser_currency_change_warning1"
								>Currency can't be changed after publishing.
							</span>
						</div>
						<div class="flex">
							&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
								i18n="@@create_fundraiser_currency_change_warning2"
								>Add a bank account in this currency to avoid exchange fees.
							</span>
						</div>
						<div class="flex">
							&nbsp;&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
								i18n="@@create_fundraiser_currency_change_warning3"
								>Connected fundraisers always have the same currency as your
								primary fundraiser.
							</span>
						</div>
					</div>
					<div class="flex flex-row gap-2 mt-6 mb-5">
						<mat-slide-toggle
							color="primary"
							[(ngModel)]="showTargetAmount"
							[ngModelOptions]="{ standalone: true }"
							name="targetToggle"
						></mat-slide-toggle>
						<span
							class="text-16 font-500"
							i18n="@@create_fundraiser_set_target_amount"
							>Set target amount</span
						>
					</div>
					<div class="flex flex-col" *ngIf="showTargetAmount">
						<mat-form-field
							class="w-100"
							appearance="outline"
							floatLabel="always"
						>
							<input
								matInput
								type="number"
								formControlName="target_amount"
								placeholder="{{ TargetAmountPlaceholder }}"
								appNumericInput
								(input)="
									createFundraiserForm.controls['target_amount'].markAsTouched()
								"
							/>
							<span matPrefix class="ml-4"
								>{{ this.selectedSymbol }}&nbsp;</span
							>

							<mat-error
								i18n="@@createFundraiser_decimal_error"
								*ngIf="
									createFundraiserForm.controls['target_amount'].errors &&
									createFundraiserForm.controls['target_amount'].errors.pattern
								"
							>
								Amount should not contain decimals
							</mat-error>

							<mat-error
								*ngIf="
									createFundraiserForm.controls['target_amount'].errors &&
									createFundraiserForm.controls['target_amount'].errors.max
								"
							>
								<span i18n="@@custom_donation_form_amountTargetMax_error">
									Maximum required amount is</span
								>&nbsp;{{ selectedSymbol }}{{ maxTargetAmount | number }}
							</mat-error>
						</mat-form-field>
					</div>
					<div class="flex flex-row gap-2 mb-5">
						<mat-slide-toggle
							color="primary"
							[(ngModel)]="showEndDate"
							[ngModelOptions]="{ standalone: true }"
							name="dateToggle"
						></mat-slide-toggle>
						<span
							class="text-16 font-500"
							i18n="@@create_fundraiser_set_date_range"
							>Set date range</span
						>
					</div>
					<div class="flex flex-col" *ngIf="showEndDate">
						<mat-form-field class="w-100" appearance="outline">
							<input
								class="targetAmount"
								matInput
								[matDatepicker]="picker"
								formControlName="end_date"
								[min]="minEndDate"
								onkeydown="return false"
								(focus)="picker.open()"
								(click)="picker.open()"
								placeholder="{{ DateRangePlaceholder }}"
							/>
							<mat-datepicker-toggle
								class="datePicker"
								matSuffix
								[for]="picker"
							></mat-datepicker-toggle>
							<mat-datepicker #picker></mat-datepicker>
							<mat-error
								*ngIf="this.createFundraiserForm.controls['end_date'].errors"
								i18n="@@create_fundraiser_wrong_date_format"
								>Wrong Date format.</mat-error
							>
						</mat-form-field>
					</div>
					<div class="flex flex-row gap-2 mb-4">
						<mat-slide-toggle
							color="primary"
							[checked]="true"
							(toggleChange)="changeShowTotalAmountDonated()"
						></mat-slide-toggle>
						<span
							class="text-16 font-500"
							i18n="
								@@custom_donation_amount_edit_show_total_amount_donated_label"
							>Show total amount donated</span
						>
					</div>
					<div class="flex flex-row gap-2">
						<mat-slide-toggle
							color="primary"
							[checked]="true"
							(toggleChange)="changeAllowConnectedFundraiser()"
						></mat-slide-toggle>
						<span
							class="text-16 font-500"
							i18n="@@custom_donation_amount_edit_all_connected_label"
							>Allow connected fundraisers</span
						>
					</div>
					<div class="flex flex-col items-start mb-3">
						<a mat-button color="accent" [href]="howItWorksHref" target="_blank"
							><span
								class="text-14 font-400"
								i18n="@@connectFundraiser_howItWorks_button"
								>How it works</span
							><span>?</span></a
						>
					</div>
					<div class="flex flex-col">
						<!-- <mat-divider></mat-divider> -->
					</div>
					<div
						[class]="
							'flex w-full lg:static fixed left-0 right-0 z-50 bg-white border-t pt-2 border-gray-200 ' +
							bottomOffset
						"
					>
						<div
							class="pr-6 pl-6 pb-3 pt-1 sm:pr-6 sm:pl-[80px] sm:pb-3 sm:pt-1 lg:pb-0 lg:pr-0 lg:pl-0 lg:pt-0 justify-between flex w-full"
						>
							<button
								mat-stroked-button
								color="accent"
								(click)="goToPreviousStep()"
								class="min-h-[48px] h-auto"
							>
								<span class="text-20 font-500 p-6" i18n="@@backButton"
									>Back</span
								>
							</button>

							<button
								id="saveBtn"
								mat-flat-button
								color="accent"
								[disabled]="
									!this.createFundraiserForm.valid ||
									!currencySearchControl.value
								"
								(click)="this.saveFundraiser()"
								class="min-h-[48px] h-auto"
							>
								<span i18n="@@button_next" class="text-20 font-500 p-6"
									>Next</span
								>
							</button>
						</div>
					</div>
				</div>
			</div>
			<ng-template #videoContainer>
				<div
					class="border border-dashed border-[#c3c3c3] hover:border-[#777777] pl-4 pr-4 pt-4"
				>
					<div class="flex flex-col mb-4">
						<div class="flex items-center gap-3">
							<img
								src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/addImageIcon/public"
							/>
							<span
								class="text-16 font-500 inline"
								i18n="@@createFundraiser_video_upload_title"
								>Paste URL for the video</span
							>
						</div>
					</div>

					<div *ngIf="videoPath && youtubeIframe" class="mb-4">
						<div [innerHTML]="youtubeIframe" class="w-full aspect-ratio"></div>
					</div>

					<div class="flex flex-col">
						<mat-form-field class="w-full" appearance="outline">
							<mat-label i18n="@@createFundraiser_video_upload_label">
								Add the YouTube or Vimeo video URL
							</mat-label>
							<input
								matInput
								formControlName="VideoName"
								placeholder="Add the YouTube or Vimeo video URL"
								(blur)="handleVideoUrlChange()"
								id="VideoName"
							/>
							<span matSuffix class="pr-1">
								<button
									*ngIf="!videoPath"
									mat-flat-button
									color="accent"
									aria-label="Apply Video URL"
									class="min-h-[48px] h-auto"
									(click)="handleVideoUrlChange()"
								>
									<span class="text-20 font-500 p-6" i18n="@@text_upload"
										>Upload</span
									>
								</button>
								<button
									*ngIf="videoPath"
									mat-stroked-button
									color="accent"
									aria-label="Clear Video URL"
									class="min-h-[48px] h-auto"
									(click)="clearVideoUrl()"
								>
									<span class="text-20 font-500 p-6" i18n="@@text_clear"
										>Clear</span
									>
								</button></span
							>
						</mat-form-field>

						<mat-error
							*ngIf="createFundraiserForm.get('VideoName')?.hasError('invalid')"
						>
							<ng-container i18n="@@account_components_InvalidUrl">
								Invalid URL
							</ng-container>
						</mat-error>
						<mat-error
							*ngIf="
								createFundraiserForm
									.get('VideoName')
									?.hasError('vimeoInvalidId')
							"
						>
							<ng-container i18n="@@account_components_VimeoUrlNoTVideo">
								Please use the embed Vimeo link like:
								https://vimeo.com/123456789
							</ng-container>
						</mat-error>
					</div>
				</div>
			</ng-template>
			<ng-template #imageContainer>
				<div
					class="border border-dashed border-[#c3c3c3] hover:border-[#777777] p-4"
				>
					<div class="flex flex-row justify-between items-center">
						<div class="flex flex-col mb-2">
							<div class="flex items-center gap-3">
								<img
									src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/addImageIcon/public"
								/>
								<span
									class="text-16 font-500 inline"
									i18n="@@backgroundImageEditDialog_editFundraiserImage_title"
									>Upload Image</span
								>
							</div>
						</div>
						<div *ngIf="this.imagePath">
							<input fxHide type="file" id="upload_image_input" />
							<button
								mat-stroked-button
								color="accent"
								(click)="this.openImageCropperDialog()"
								class="min-h-[48px] h-auto bg-white"
							>
								<span class="text-20 font-500 p-6" i18n="@@text_change"
									>Change</span
								>
							</button>
						</div>
					</div>
					<div class="flex flex-col mt-2">
						<mat-label
							>&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
								i18n="@@createFundraiser_image_upload_hint1"
								>Use JPG, PNG, or WebP (Max 5MB, Min.1600px wide)</span
							></mat-label
						>
					</div>
					<div class="flex flex-col">
						<mat-label
							>&nbsp;&nbsp;&bull;&nbsp;&nbsp;<span
								i18n="@@createFundraiser_image_upload_hint2"
								>For best results, use a horizontal video with a 16:9 or 4:3
								aspect ratio.</span
							></mat-label
						>
					</div>
					<div *ngIf="this.imagePath" class="pt-3 pb-2">
						<img class="img-preview" class="w-full" [src]="this.imagePath" />
					</div>
					<div class="flex flex-col mt-2" *ngIf="!this.imagePath">
						<input fxHide type="file" id="upload_image_input" />
						<button
							class="w-full"
							mat-flat-button
							color="accent"
							(click)="this.openImageCropperDialog()"
							class="min-h-[48px] h-auto"
						>
							<span class="text-20 font-500 p-6" i18n="@@text_upload"
								>Upload</span
							>
						</button>
					</div>
				</div>
			</ng-template>
		</form>
	</div>
</div>
<div
	*ngIf="showMediaSwitchPopup"
	class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
>
	<div class="white-bg p-4 rounded-lg shadow-lg max-w-md w-full">
		<div class="flex justify-end" (click)="cancelMediaSwitch()">
			<span class="material-icons-outlined"> cancel </span>
		</div>
		<div class="flex flex-col mb-3">
			<span class="text-lg font-bold" i18n="@@mediaSwitchPopup_replaceMedia"
				>Replace the existing media?</span
			>
		</div>
		<div class="inline">
			<span i18n="@@mediaSwitchPopup_warning_1">
				This will permanently remove your current</span
			>
			{{ imagePath ? textImage : textVideo }}.
			<span i18n="@@mediaSwitchPopup_warning_2">
				Are you sure you want to proceed?</span
			>
		</div>
		<div class="flex justify-end gap-4 mt-4">
			<button
				mat-stroked-button
				color="accent"
				(click)="cancelMediaSwitch()"
				i18n="@@button_cancel"
			>
				Cancel
			</button>
			<button
				mat-flat-button
				color="accent"
				(click)="confirmMediaSwitch()"
				i18n="@@button_replace"
			>
				Yes, replace
			</button>
		</div>
	</div>
</div>
